import getAllLawyers from '../../api/queries/lawyers/getAllLawyers';
import createApolloClient from '../../api/index';
import getMenu from '../../api/queries/menus/getMenu';
import Breadcrumb from '../../components/Breadcrumb';

import { ReactComponent as TiltedArrow } from '../../public/images/blue-down-arrow.svg';
import Reviews from '../../components/Reviews';

import PageLayout from '../../components/PageLayout';

const client = createApolloClient();

const Team = ({ data, desktopHeaderData, aboutMenuData, serviceMenuData, toolsMenuData }) => {
  const pageName = {
    pageBy: {
      title: 'Team',
      slug: 'team',
    },
  };
  const indexStatus = {
    indexPage: true,
  };
  const yoastSeo = {
    title: 'Meet the lawyers at Monaco Solicitors | Employment specialists',
    description:
      'Meet members of Monaco Solicitors’ legal team, with brief outlines of their employment law experience and particular areas of interest',
  };

  return (
    <PageLayout
      menuData={desktopHeaderData}
      aboutMenuData={aboutMenuData}
      toolsMenuData={toolsMenuData}
      serviceMenuData={serviceMenuData}
      title="Team"
      classNames="team"
      indexStatus={indexStatus}
      seo={yoastSeo}
    >
      <Breadcrumb data={pageName} />
      <h1>Meet Our Team</h1>

      {(() => {
        const allLawyers = data.lawyers.nodes;
        const leadershipSlugs = ['alex-monaco', 'dmitrii-rudenko'];
        const leadership = leadershipSlugs
          .map((slug) => allLawyers.find((l) => l.slug === slug))
          .filter(Boolean);
        const rest = allLawyers.filter((l) => !leadershipSlugs.includes(l.slug));

        const renderLawyer = (lawyer) => {
          const quoteSection = lawyer.sections.sections.find(
            (section) => section.fieldGroupName === 'Team_Sections_Sections_Quote',
          );

          const imageSection = lawyer.sections.sections.find(
            (section) => section.fieldGroupName === 'Team_Sections_Sections_Image',
          );

          const imageUrl = imageSection?.image?.mediaItemUrl.replace(
            'http://127.0.0.1',
            'https://monacosolicitors.co.uk',
          );

          return (
            <div className="team__lawyer" key={lawyer.slug}>
              <div>
                <div
                  className="team__lawyer__portrait"
                  style={{ backgroundImage: `url(${imageUrl}` }}
                />
                <h6>{lawyer.title}</h6>
                <p>
                  <small>{lawyer.lawyers.jobTitle}</small>
                </p>
              </div>
              {quoteSection && <p className="body_2">"{quoteSection.quote}"</p>}
              <div className="team__lawyer__link">
                <TiltedArrow />
                <a href={`team/${lawyer.slug}`}>View Profile</a>
              </div>
            </div>
          );
        };

        return (
          <>
            <div className="team__lawyers team__lawyers--leadership">
              {leadership.map(renderLawyer)}
            </div>
            <div className="team__lawyers">
              {rest.map(renderLawyer)}
            </div>
          </>
        );
      })()}
      <div className="team__video">
        <div className="team__video__container">
          <h5>We are proud to say</h5>
          <h6>Ellie Reeves MP</h6>
          <div>
            <p className="body_2">
              One of our very own lawyers here at Monaco Solicitors from April 2016 to June 2017, is
              now MP for Lewisham West and Penge.
            </p>
            {/* <p className="body_2">
              After seeing her in action on our employment law cases, we’re excited to see that she
              has now been appointed the Shadow Solicitor General.
            </p> */}
          </div>
        </div>
      </div>
      <div className="team__review">
        <Reviews>
          <div>
            <h6>
              Enquire about first
              <br /> class representation
            </h6>
            <a href="/contact-us" className="button">
              ENQUIRE NOW
            </a>
          </div>
        </Reviews>
      </div>
    </PageLayout>
  );
};

export default Team;

export async function getStaticProps() {
  const { data } = await client.query(getAllLawyers());
  const serviceMenuId = process.env.APP_ENV === 'stage' ? 'dGVybTo2Mg==' : 'dGVybTo2Ng==';
  const desktopHeaderData = await client.query(getMenu('dGVybToyNQ=='));
  const aboutMenuData = await client.query(getMenu('dGVybTo1NQ=='));
  const serviceMenuData = await client.query(getMenu(serviceMenuId));
  const toolsMenuData = await client.query(getMenu('dGVybTo1Ng=='));

  return { props: { data, desktopHeaderData, aboutMenuData, serviceMenuData, toolsMenuData }, revalidate: 10 };
}
